import React from "react";
import { Lightbulb, Fan, Snowflake, Blinds, Tv, Lock, Camera, Zap, Droplet, ShieldCheck, Plug, Radar } from "lucide-react";

const cards = [
    { icon: Lightbulb, title: "Smart Lighting", desc: "Dim, schedule, group and voice-control every light.", span: "lg:col-span-4" },
    { icon: Snowflake, title: "AC & Climate", desc: "Turn any AC into a smart one — no new AC needed.", span: "lg:col-span-4" },
    { icon: Blinds, title: "Smart Curtains", desc: "Motorised curtains that follow your routine.", span: "lg:col-span-4" },
    { icon: Fan, title: "Fans", desc: "Speed & schedule control from anywhere.", span: "lg:col-span-3" },
    { icon: Tv, title: "TV & Entertainment", desc: "Voice-controlled scenes for movie night.", span: "lg:col-span-3" },
    { icon: Lock, title: "Smart Locks", desc: "Fingerprint, PIN, remote unlock, video log.", span: "lg:col-span-3" },
    { icon: Camera, title: "Cameras", desc: "Live surveillance, motion alerts, night vision.", span: "lg:col-span-3" },
    { icon: Plug, title: "Smart Plugs", desc: "Any appliance becomes voice-controlled instantly.", span: "lg:col-span-3" },
    { icon: Radar, title: "Sensors & Automation", desc: "Motion, door, gas — reactive intelligence.", span: "lg:col-span-3" },
    { icon: Zap, title: "Energy Management", desc: "Track and reduce power consumption per room.", span: "lg:col-span-3" },
    { icon: Droplet, title: "Water Heater Control", desc: "Warm water waiting — right when you wake up.", span: "lg:col-span-3" },
];

export default function WhatCanYouAutomate() {
    return (
        <section className="max-w-7xl mx-auto px-5 sm:px-8 py-24" data-testid="what-can-you-automate">
            <div className="flex flex-col md:flex-row md:items-end justify-between gap-6 mb-10">
                <div>
                    <div className="text-xs tracking-[0.2em] uppercase text-[#1BB6F0] font-semibold">Solutions</div>
                    <h2 className="mt-3 text-3xl sm:text-4xl lg:text-5xl font-semibold tracking-tight text-[#1B2E7A] leading-tight">
                        What can you automate?
                    </h2>
                </div>
                <p className="text-slate-600 max-w-md">
                    Almost everything in your home — retrofitted to work with what you already own.
                </p>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-12 gap-4">
                {cards.map((c, i) => (
                    <div
                        key={i}
                        data-testid={`automate-card-${i}`}
                        className={`group ${c.span} bg-white border border-slate-200 rounded-3xl p-6 lg:p-7 hover:border-[#1BB6F0]/60 hover:shadow-xl hover:shadow-[#1B2E7A]/10 transition-[border-color,box-shadow,transform] duration-300 hover:-translate-y-1`}
                    >
                        <div className="w-11 h-11 rounded-2xl bg-[#E8F8FE] text-[#1BB6F0] flex items-center justify-center mb-5 group-hover:bg-[#1BB6F0] group-hover:text-white transition-colors">
                            <c.icon className="w-5 h-5" strokeWidth={2} />
                        </div>
                        <div className="text-lg font-semibold text-[#1B2E7A]">{c.title}</div>
                        <div className="mt-1.5 text-sm text-slate-600 leading-relaxed">{c.desc}</div>
                    </div>
                ))}
            </div>
        </section>
    );
}
